<template>
    <div id="app">
        <div class="container">
            <Form />
        </div>
    </div>
</template>

<script>
    import Form from './components/Form'
    import StatisticsForm from './components/StatisticsForm'
    import AdvancedStatisticsForm from './components/AdvancedStatisticsForm'
    import KosovoStatisticsForm from './components/KosovoStatisticsForm'
    import KosovoAdvancedStatisticsForm from './components/KosovoAdvancedStatisticsForm'
    export default {
        name: 'App',
        props: ['formType'],
        components: {
            Form
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue